import React from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import Button from "react-bootstrap/lib/Button";

import HomeTypeSlider from "../Filters/HomeTypeSlider/HomeTypeSlider";
import MoreFiltersModal from '../../MoreFiltersModal/MoreFiltersModal';

import messages from "../../../locale/messages";

import FilterIcon from '../../Common/SvgIcons/FilterIcon';
import s from "./SearchHeader.css";
import personajeLupa from '/public/SiteImages/personaje-lupa.svg';

class WebFilter extends React.Component {


    render() {
        const { roomType, handleOpen, handleTabToggle, searchSettings, isExpand } = this.props;
        const { smallDevice, tabletDevice, verySmallDevice, showFilter, showResults, isActiveMoreFilter } = this.props;

        return (
            <div
                className={cx(
                    s.searchHeaderResponsiveScroll,
                    "searchHeaderScroll"
                )}
            >
                <div className={s.searchHeaderResponsive}>
                    <div className={s.filterRow}>
                        <div className={cx(s.filterButtonContainer, 'hidden-xs')}>
                            <Button
                                className={cx(s.filterBtn, isActiveMoreFilter && s.filterBtnIsActive)}
                                onClick={handleOpen}
                            >
                                <span className={cx(s.btnFlex, 'svgImg')}>
                                    <span><FormattedMessage {...messages.filters} /></span>
                                    <FilterIcon />
                                </span>
                            </Button>
                            <MoreFiltersModal
                                className={s.filterButtonContainer}
                                handleTabToggle={handleTabToggle}
                                isExpand={isExpand}
                                searchSettings={searchSettings}
                                smallDevice={smallDevice}
                                tabletDevice={tabletDevice}
                                verySmallDevice={verySmallDevice}
                                showFilter={showFilter}
                                showResults={showResults}
                            />
                        </div>
                        <div className={s.divider}></div>
                        <HomeTypeSlider
                            className={s.chipsWrapper}
                            roomType={roomType}
                        />
                        <img src={personajeLupa} className={s.lupaCharacter} alt="" />
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(withStyles(s)(WebFilter));